import "../normalize.css";
import "../shared.css";
import "./blog.css";

document.addEventListener("DOMContentLoaded", () => {
    console.log("Blog Page JS Loaded");
});
